class VariantSelector {
  constructor() {


    this.variantSwatchesNormalized = this.buildVariantSwatchLookup();

    this.selectedOptions = {
      color: null,
      quantities: {}
    };

    this.init();
    console.log('VariantSelector initialized');
  }

  init() {
    console.log('VariantSelector init called');
    this.container = document.querySelector('.product-variant-selector');
    if (!this.container) {
      console.log('No product-variant-selector container found');
      return;
    }
    console.log('Found product-variant-selector container');
    
    this.swatchSource = this.container.getAttribute('data-swatch-source') || 'auto_swatch';
    // Default CDN template (hardcoded)
    this.autoSwatchTemplate = 'https://cdn.shopify.com/s/files/1/0651/6172/4123/files/__TOKEN__.png';
    this.autoSwatchFormat = 'original_snake';
    this.customSwatches = this.parseCustomSwatches(this.container.getAttribute('data-custom-swatches'));
    this.productForm = document.querySelector('product-form');
    this.variantRadios = document.querySelector('variant-radios');
    this.variantSelects = document.querySelector('variant-selects');
    this.setupColorSwatches();
    this.setupQuantityControls();
    this.setupAddToCartButton();
    this.bindEvents();
  }

  setupColorSwatches() {
    const colorVariants = this.getUniqueColorOptions();
    const swatchContainer = this.container.querySelector('.swatch-container');
    const variantLabel = this.container.querySelector('.variant-label');
    if (!swatchContainer || !variantLabel) return;

    const labelContainer = document.createElement('div');
    labelContainer.className = 'variant-label-container';
    variantLabel.parentNode.insertBefore(labelContainer, variantLabel);
    labelContainer.appendChild(variantLabel);

    const selectedColorSpan = document.createElement('span');
    selectedColorSpan.className = 'selected-color';
    labelContainer.appendChild(selectedColorSpan);

    variantLabel.textContent = 'Selected Color:';
    swatchContainer.innerHTML = '';

    const useVariantImages = (this.swatchSource === 'variant_image');

    colorVariants.forEach(color => {
      const swatch = document.createElement('div');
      swatch.className = 'swatch-element';
      swatch.setAttribute('data-color', color);

      const tooltip = document.createElement('span');
      tooltip.className = 'swatch-tooltip';
      tooltip.textContent = this.formatColorName(color);
      swatch.appendChild(tooltip);

      const variantForColor = this.getVariantForColor(color);
      const normalizedColorKey = this.normalizeColorKey(color);
      const variantImageSrc = variantForColor?.featured_image?.src;
      let swatchData = {};

      if (this.swatchSource === 'variant_image') {
        // Mode 1: Product images only - no auto swatches
        if (variantImageSrc) {
          swatchData = this.mergeSwatchData(swatchData, { img: variantImageSrc }, { preserveImageOnHex: true });
        }
        
        // Still allow custom swatches override
        const customSwatch = this.customSwatches[normalizedColorKey];
        if (customSwatch) {
          console.log(`[Swatch Priority] Using custom JSON for "${color}"`);
          swatchData = this.mergeSwatchData(swatchData, customSwatch, { preserveImageOnHex: false });
        }
      } else {
        // Mode 2: Auto swatch from Shopify Files (default)
        
        // Priority 1: Automatic token-based URL from Shopify Files
        const autoSwatchUrl = this.buildAutoSwatchUrl(color);
        if (autoSwatchUrl) {
          swatchData = this.mergeSwatchData(swatchData, { img: autoSwatchUrl }, { preserveImageOnHex: true });
        }

        // Priority 2: Custom swatches (JSON) - manual override
        const customSwatch = this.customSwatches[normalizedColorKey];
        if (customSwatch) {
          console.log(`[Swatch Priority] Using custom JSON for "${color}"`);
          swatchData = this.mergeSwatchData(swatchData, customSwatch, { preserveImageOnHex: false });
        }

        // Priority 3: Variant featured image (fallback if auto file doesn't exist)
        // This will be handled by img.onerror below
      }

      if (swatchData.img) {
        const img = document.createElement('img');
        const imgUrl = this.ensureAbsoluteUrl(swatchData.img);
        img.src = imgUrl;
        img.alt = this.formatColorName(color);
        
        // Fallback to variant image if custom swatch file doesn't exist
        img.onerror = () => {
          if (variantImageSrc && imgUrl !== variantImageSrc) {
            console.log(`[Swatch Fallback] File not found for "${color}", using variant image`);
            img.src = variantImageSrc;
          }
        };
        
        swatch.appendChild(img);
      } else if (swatchData.hex) {
        swatch.style.backgroundColor = swatchData.hex;
      } else {
        const cssColor = this.getCssColorFromName(color);
        swatch.style.backgroundColor = cssColor || '#ccc';
      }

      swatchContainer.appendChild(swatch);
    });

    const firstSwatch = swatchContainer.querySelector('.swatch-element');
    if (firstSwatch) {
      this.handleColorSelection(firstSwatch);
    }
  }

  updateSizeOptions(selectedColor) {
    const sizeGrid = this.container.querySelector('.size-grid');
    if (!sizeGrid) return;
    
    const colorPos = this.getColorOptionPosition();
    const colorKey = `option${colorPos}`;
    const colorVariants = window.productVariants.filter(v => v[colorKey] === selectedColor);

    sizeGrid.innerHTML = '';

    colorVariants.forEach(variant => {
      const variantData = document.querySelector(`[data-variant-inventory="${variant.id}"]`);
      const inventory = variantData ? parseInt(variantData.textContent) : 0;
      const isAvailable = inventory > 0;

      const sizeBox = document.createElement('div');
      sizeBox.className = `size-box${!isAvailable ? ' out-of-stock' : ''}`;
      sizeBox.setAttribute('data-value', variant.option2);
      sizeBox.setAttribute('data-variant-id', variant.id);

      let stockText = isAvailable ? `${inventory}` : 'OUT';
      let stockCount = isAvailable ? inventory : 0;

      sizeBox.innerHTML = `
        <div class="size-name">${variant.option2}</div>
        <div class="variant-price">${this.formatMoney(variant.price)}</div>
        <div class="variant-stock">
          ${isAvailable ?
            `<div class="quantity-controls">
              <button type="button" class="quantity-btn quantity-btn--minus">-</button>
              <input type="number"
                     class="quantity-input"
                     value="0"
                     min="0"
                     max="${stockCount}"
                     data-variant-id="${variant.id}">
              <button type="button" class="quantity-btn quantity-btn--plus">+</button>
            </div>
            <span class="stock-count">${stockText}</span>` :
            'OUT'}
        </div>
      `;

      sizeGrid.appendChild(sizeBox);
    });

    this.setupQuantityControls();
    this.updateTotalQuantity();
  }

  setupQuantityControls() {
    this.container.querySelectorAll('.quantity-controls').forEach(control => {
      const minusBtn = control.querySelector('.quantity-btn--minus');
      const plusBtn = control.querySelector('.quantity-btn--plus');
      const input = control.querySelector('.quantity-input');

      minusBtn.replaceWith(minusBtn.cloneNode(true));
      plusBtn.replaceWith(plusBtn.cloneNode(true));
      input.replaceWith(input.cloneNode(true));

      const newMinusBtn = control.querySelector('.quantity-btn--minus');
      const newPlusBtn = control.querySelector('.quantity-btn--plus');
      const newInput = control.querySelector('.quantity-input');

      const variantId = newInput.dataset.variantId;
      const maxQuantity = parseInt(newInput.getAttribute('max')) || 9999;
      this.selectedOptions.quantities[variantId] = 0;

      newMinusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const currentValue = parseInt(newInput.value) || 0;
        if (currentValue > 0) {
          newInput.value = currentValue - 1;
          this.selectedOptions.quantities[variantId] = currentValue - 1;
          this.updateTotalQuantity();
        }
      });

      newPlusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const currentValue = parseInt(newInput.value) || 0;
        if (currentValue < maxQuantity) {
          newInput.value = currentValue + 1;
          this.selectedOptions.quantities[variantId] = currentValue + 1;
          this.updateTotalQuantity();
        }
      });

      newInput.addEventListener('change', () => {
        let value = parseInt(newInput.value) || 0;
        if (value < 0) value = 0;
        if (value > maxQuantity) value = maxQuantity;
        newInput.value = value;
        this.selectedOptions.quantities[variantId] = value;
        this.updateTotalQuantity();
      });
    });
  }

  updateTotalQuantity() {
    const totalQuantity = Object.values(this.selectedOptions.quantities)
      .reduce((sum, qty) => sum + qty, 0);

    const addToCartBtn = document.querySelector('.product-form__submit');
    if (addToCartBtn) {
      const minQtyAttr = parseInt(this.container.getAttribute('data-min-qty')) || 0;
      const minQty = Number.isFinite(minQtyAttr) ? minQtyAttr : 0;
      const hasMinRequirement = minQty > 0;
      const warningEl = this.container.querySelector('.min-qty-warning');
      const meetsMin = hasMinRequirement ? totalQuantity >= minQty : totalQuantity > 0;

      addToCartBtn.disabled = !meetsMin;

      const label = addToCartBtn.querySelector('.atc-label');
      if (label) {
        if (totalQuantity === 0) {
          label.textContent = 'Select Options';
        } else if (hasMinRequirement && totalQuantity < minQty) {
          label.textContent = `Add ${minQty - totalQuantity} more`;
        } else {
          label.textContent = 'Add to Cart';
        }
      }

      if (warningEl) {
        warningEl.style.display = hasMinRequirement && totalQuantity > 0 && totalQuantity < minQty ? 'block' : 'none';
      }
    }
  }

  setupAddToCartButton() {
    console.log('setupAddToCartButton called');
    const addToCartBtn = document.querySelector('.product-form__submit');
    if (addToCartBtn) {
      console.log('Found add to cart button, adding event listener');
      addToCartBtn.addEventListener('click', () => this.addToCart());
    } else {
      console.log('No add to cart button found');
    }
  }

  bindEvents() {
    this.container.addEventListener('click', (e) => {
      const swatch = e.target.closest('.swatch-element');
      if (swatch) {
        this.handleColorSelection(swatch);
      }
    });
  }

  handleColorSelection(swatch) {
    const color = swatch.getAttribute('data-color');
    this.selectedOptions.color = color;

    const selectedColorSpan = this.container.querySelector('.selected-color');
    if (selectedColorSpan) {
      selectedColorSpan.textContent = this.formatColorName(color);
    }

    this.container.querySelectorAll('.swatch-element').forEach(el => {
      el.classList.remove('selected');
    });
    swatch.classList.add('selected');

    const selectedVariant = this.getVariantForColor(color);
    if (!selectedVariant) return;

    this.triggerVariantChange();

    const matchingThumb = document.querySelector(`a[data-id="${selectedVariant.featured_media?.id}"]`);
    if (matchingThumb) {
      matchingThumb.click();
    }

    document.dispatchEvent(new CustomEvent('variant:color-change', { detail: { color, variant: selectedVariant } }));
    this.updateSizeOptions(color);
  }

  formatColorName(color) {
    return color.replace(/\s*-\s*\d+$/, '').trim();
  }

  triggerVariantChange() {
    if (!this.selectedOptions.color) return;
    const variant = this.getVariantForColor(this.selectedOptions.color);
    if (!variant) return;

    if (this.variantRadios) {
      const input = this.variantRadios.querySelector(`input[value="${variant.id}"]`);
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (this.variantSelects) {
      const select = this.variantSelects.querySelector('select');
      if (select) {
        select.value = variant.id;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (this.productForm) {
      const input = this.productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    this.container.dispatchEvent(new CustomEvent('on:variant:change', {
      detail: { variant },
      bubbles: true
    }));
  }

  addToCart() {
    console.log('addToCart called');
    const minQtyAttr = parseInt(this.container.getAttribute('data-min-qty')) || 0;
    const minQty = Number.isFinite(minQtyAttr) ? minQtyAttr : 0;
    if (minQty > 0) {
      const totalQuantity = Object.values(this.selectedOptions.quantities)
        .reduce((sum, qty) => sum + qty, 0);
      if (totalQuantity < minQty) {
        const warningEl = this.container.querySelector('.min-qty-warning');
        if (warningEl) {
          warningEl.style.display = 'block';
        }
        return;
      }
    }

    const items = [];
    Object.entries(this.selectedOptions.quantities).forEach(([variantId, quantity]) => {
      if (quantity > 0) {
        items.push({
          id: parseInt(variantId, 10),
          quantity: quantity
        });
      }
    });

    if (items.length === 0) {
      alert('Please select at least one size and quantity');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items })
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(() => {
        console.log('Product added to cart successfully');
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        } else if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        }

        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        document.dispatchEvent(new CustomEvent('cart:updated'));

        this.container.querySelectorAll('.quantity-input').forEach(input => {
          input.value = 0;
        });
        this.selectedOptions.quantities = {};
        this.updateTotalQuantity();
      })
      .catch((error) => {
        console.error('[VariantSelector] Cart add error:', error);
        alert('Failed to add product to cart. Please try again.');
      });
  }

  getColorOptionPosition() {
    // Determine which option position is color (can be option1, option2, or option3)
    const colorSelector = this.container.querySelector('.variant-selector--color');
    if (!colorSelector) return 1;
    const position = parseInt(colorSelector.getAttribute('data-option-position')) || 1;
    return position;
  }

  getSizeOptionPosition() {
    const sizeSelector = this.container.querySelector('.variant-selector--size');
    if (!sizeSelector) return 2;
    const position = parseInt(sizeSelector.getAttribute('data-option-position')) || 2;
    return position;
  }

  getUniqueColorOptions() {
    const colorPos = this.getColorOptionPosition();
    const optionKey = `option${colorPos}`;
    return [...new Set(window.productVariants.map(variant => variant[optionKey]))];
  }

  getVariantForColor(color) {
    const colorPos = this.getColorOptionPosition();
    const optionKey = `option${colorPos}`;
    return window.productVariants.find((variant) => variant[optionKey] === color);
  }

  getCssColorFromName(color) {
    if (!color) return null;
    const tester = document.createElement('option');
    const normalized = color.toLowerCase().replace(/\s+/g, '');
    tester.style.color = normalized;
    if (tester.style.color) return normalized;
    tester.style.color = color;
    return tester.style.color || null;
  }

  ensureAbsoluteUrl(url) {
    if (!url) return url;
    if (url.startsWith('//')) return `https:${url}`;
    if (url.startsWith('http')) return url;
    if (url.startsWith('/')) return `${window.location.origin}${url}`;
    return url;
  }

  parseCustomSwatches(raw) {
    const result = {};
    if (!raw) return result;
    const decoded = raw.replace(/&quot;/g, '"');
    
    // Try JSON format first
    try {
      const parsed = JSON.parse(decoded);
      if (parsed && typeof parsed === 'object') {
        // Normalize keys to lowercase for matching
        Object.entries(parsed).forEach(([name, value]) => {
          const key = this.normalizeColorKey(name);
          if (key && value && typeof value === 'object') {
            result[key] = value;
          }
        });
        return result;
      }
    } catch (err) {
      // Fallback to line-by-line format: "Color: #hex" or "Color: url"
      console.log('[VariantSelector] JSON parse failed, trying line format');
    }

    // Parse line-by-line format: "White: #ffffff;orange:#FE6636;"
    decoded
      .split(/[;\r\n]+/)
      .forEach((line) => {
        const trimmed = line.trim();
        if (!trimmed) return;
        const separatorIndex = trimmed.indexOf(':');
        if (separatorIndex === -1) return;
        const name = trimmed.slice(0, separatorIndex).trim();
        const key = this.normalizeColorKey(name);
        if (!key) return;
        const value = trimmed.slice(separatorIndex + 1).trim();
        if (!value) return;
        if (value.startsWith('#')) {
          result[key] = { hex: value };
          console.log(`[Custom Swatch] "${name}" → hex: ${value}`);
        } else if (value.startsWith('http')) {
          result[key] = { img: value };
          console.log(`[Custom Swatch] "${name}" → img: ${value}`);
        }
      });

    return result;
  }

  parseColorLibrary(raw) {
    if (!raw) return {};
    try {
      const parsed = JSON.parse(raw.replace(/&quot;/g, '"'));
      if (Array.isArray(parsed)) {
        return parsed.reduce((acc, entry) => {
          if (!entry || !entry.name) return acc;
          const key = this.normalizeColorKey(entry.name);
          if (!key) return acc;
          acc[key] = {};
          if (entry.hex) acc[key].hex = entry.hex;
          if (entry.img) acc[key].img = this.ensureAbsoluteUrl(entry.img);
          return acc;
        }, {});
      }
      if (parsed && typeof parsed === 'object') {
        return parsed;
      }
      return {};
    } catch (err) {
      console.warn('[VariantSelector] Failed to parse color library data', err);
      return {};
    }
  }

  normalizeColorKey(name) {
    if (!name && name !== 0) return null;
    return name.toString().trim().toLowerCase();
  }

  buildAutoSwatchToken(name) {
    if (!this.autoSwatchTemplate || !name) return null;
    const base = name
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, 'and')
      .replace(/@/g, 'at');
    const collapsed = base.replace(/[^a-zA-Z0-9]+/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_+|_+$/g, '');

    switch (this.autoSwatchFormat) {
      case 'lower_snake':
        return collapsed.toLowerCase();
      case 'kebab':
        return collapsed.toLowerCase().replace(/_/g, '-');
      case 'original_snake':
        return collapsed;
      case 'upper_snake':
      default:
        return collapsed.toUpperCase();
    }
  }

  buildAutoSwatchUrl(color) {
    if (!this.autoSwatchTemplate || !color) return null;
    const token = this.buildAutoSwatchToken(color);
    if (!token) return null;

    // Support multiple placeholder formats: {{token}}, {token}, [token], __TOKEN__
    const placeholders = [/\{\{token\}\}/gi, /\{token\}/gi, /\[token\]/gi, /__TOKEN__/gi];
    let result = this.autoSwatchTemplate;
    
    for (const placeholder of placeholders) {
      if (result.match(placeholder)) {
        const finalUrl = result.replace(placeholder, token);
        console.log(`[AutoSwatch] Color: "${color}" → Token: "${token}" → URL: ${finalUrl}`);
        return finalUrl;
      }
    }

    // If no placeholder found, append token to the end
    const needsSlash = !this.autoSwatchTemplate.endsWith('/') && !this.autoSwatchTemplate.includes('?');
    const finalUrl = `${this.autoSwatchTemplate}${needsSlash ? '/' : ''}${token}`;
    console.log(`[AutoSwatch] Color: "${color}" → Token: "${token}" → URL: ${finalUrl}`);
    return finalUrl;
  }

  buildVariantSwatchLookup() {
    const lookup = {};
    Object.entries(this.variantSwatches || {}).forEach(([name, value]) => {
      const key = this.normalizeColorKey(name);
      if (key && !lookup[key]) {
        lookup[key] = value;
      }
    });
    return lookup;
  }

  mergeSwatchData(base, source, options = {}) {
    if (!source) return base;
    const preserveImageOnHex = options.preserveImageOnHex ?? false;
    const result = { ...base };
    if (source.hex) {
      result.hex = source.hex;
      if (!preserveImageOnHex && result.img) {
        delete result.img;
      }
    }
    if (source.img) {
      result.img = this.ensureAbsoluteUrl(source.img);
    }
    return result;
  }

  formatMoney(cents) {
    return window.theme?.moneyFormat?.replace('{{amount}}', (cents / 100).toFixed(2)) || `$${(cents / 100).toFixed(2)}`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded - initializing VariantSelector');
  console.log('Current template:', document.body.className);
  console.log('Product variants:', window.productVariants);
  new VariantSelector();

  document.addEventListener('submit', function(e) {
    const form = e.target;
    const minQtyInput = form.querySelector('input[name="properties[_cl_options_quantity_min]"]');
    if (!minQtyInput) return;

    const minQty = parseInt(minQtyInput.value) || 0;
    if (minQty <= 0) return;

    const quantityInput = form.querySelector('input[name="quantity"]');
    if (!quantityInput) return;

    const selectedQuantity = parseInt(quantityInput.value) || 0;

    if (selectedQuantity < minQty) {
      e.preventDefault();

      let errorDiv = form.querySelector('.min-qty-error');
      if (!errorDiv) {
        errorDiv = document.createElement('div');
        errorDiv.className = 'min-qty-error';
        errorDiv.style.cssText = 'color: #b00020; margin: 8px 0 12px; padding: 8px; background: #ffebee; border: 1px solid #b00020; border-radius: 4px;';
        form.insertBefore(errorDiv, form.querySelector('.payment-buttons'));
      }

      errorDiv.textContent = `Minimum order quantity for Genuine Leather Patches is ${minQty}.`;
      errorDiv.style.display = 'block';
      errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }

    const errorDiv = form.querySelector('.min-qty-error');
    if (errorDiv) {
      errorDiv.style.display = 'none';
    }
  });
});

